export const SET_SORT_KEY = 'SET_SORT_KEY';

export const setSortKey = sortKey => ({
  type: SET_SORT_KEY,
  value: {sortKey},
});
